import { useEffect, useState, startTransition } from "react";
import { Link } from "react-router-dom";
import { BookOpen, Flame } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { tipsUrl } from "@/lib/translations";
import { TipCard } from "@/components/TipCard";

/** Startseite „Reisetipps“: neueste Menü-Seiten als Kacheln + (sobald Aufrufe vorliegen) die meistgelesenen Reisetipps. */
export const HomeTips = ({ limit = 3 }) => {
  const { t } = useLang();
  const [pages, setPages] = useState([]);
  const [popular, setPopular] = useState([]);
  useEffect(() => {
    api.get("/pages/latest", { params: { limit } }).then((r) => startTransition(() => setPages(r.data))).catch(() => setPages([]));
    api.get("/pages/tips/popular", { params: { limit } }).then((r) => startTransition(() => setPopular(r.data))).catch(() => setPopular([]));
  }, [limit]);
  if (!pages.length && !popular.length) return null;
  const Row = ({ icon: Icon, label, items, prefix }) => (
    <div data-testid={`${prefix}-row`}>
      <div className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-stone-500 mb-4"><Icon className="w-4 h-4 text-brand" />{label}</div>
      <div className="grid md:grid-cols-3 gap-6">
        {items.map((p) => <TipCard key={`${p.island || "x"}-${p.slug}`} tip={p} showIsland={!!p.island} testId={`${prefix}-${p.slug}`} />)}
      </div>
    </div>
  );
  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-10 home-section border-t border-stone-200" data-testid="home-tips">
      <div className="home-section-head flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-brand flex items-center gap-2"><BookOpen className="w-4 h-4" />{t.tips.subtitle}</div>
          <h2 className="font-serif text-4xl md:text-5xl text-stone-900 mt-3">{t.tips.title}</h2>
        </div>
        <Link to={tipsUrl()} className="text-sm text-brand font-semibold hover:underline underline-offset-4 whitespace-nowrap" data-testid="home-tips-all">{t.tips.all} →</Link>
      </div>
      <div className="space-y-12">
        {pages.length > 0 && <Row icon={BookOpen} label={popular.length ? t.tips.latest : t.tips.subtitle} items={pages} prefix="home-tip" />}
        {popular.length > 0 && <Row icon={Flame} label={t.tips.popular} items={popular} prefix="home-popular-tip" />}
      </div>
    </section>
  );
};
